// Helpers puros del bloque "Uso de coberturas" del 360 (035-coverage-usage-origin): unen los
// reembolsos con los demás usos del usuario y los dejan ordenados por fecha.
//
// Las dos fuentes entregan la fecha en formatos distintos y se leen por partes de texto, sin
// pasar por `Date`: `new Date('2026-07-08')` se interpreta en UTC y en hora de Chile caería un
// día antes.

const REFUND_DATE = /^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/;
const USAGE_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

const toRank = (year, month, day) => Number(`${year}${month}${day}`);

// El historial de reembolsos entrega DD/MM/YY con el año de 2 dígitos (así lo genera el
// backend, pese al nombre de su helper). Todo dato es del siglo 21.
export function refundDateRank(text) {
  const match = REFUND_DATE.exec(text || '');
  if (!match) return 0;
  const [, day, month, year] = match;
  return toRank(year.length === 2 ? `20${year}` : year, month, day);
}

export function usageDateRank(text) {
  const match = USAGE_DATE.exec(text || '');
  if (!match) return 0;
  const [, year, month, day] = match;
  return toRank(year, month, day);
}

// Muestra la fecha de uso con el mismo formato que las fechas del historial de reembolsos.
export function formatUsageDate(text) {
  const match = USAGE_DATE.exec(text || '');
  if (!match) return '-';
  const [, year, month, day] = match;
  return `${day}/${month}/${year.slice(2)}`;
}

function refundRow(refund, index) {
  return {
    key: `request-${index}`,
    source: 'request',
    origin: 'refund',
    membershipId: refund.membershipId || null,
    name: refund.name,
    species: refund.species,
    service: refund.service,
    referenceIndex: refund.referenceIndex,
    ces: refund.ces,
    createdAt: refund.createdAt,
    statusChangedAt: refund.statusChangedAt,
    changelog: refund.changelog,
    refundedAmount: refund.refundedAmount,
    dateRank: refundDateRank(refund.createdAt)
  };
}

// Un uso no tiene N° de reembolso, CES, cambio de estado ni estado: se marca como no
// disponible. Su monto puede ser null (dato no disponible), que no es lo mismo que "$0".
function usageRow(usage) {
  return {
    key: `usage-${usage.id}`,
    source: 'usage',
    origin: usage.origin,
    membershipId: usage.membershipId || null,
    name: usage.name,
    species: usage.species,
    service: usage.service,
    referenceIndex: '-',
    ces: null,
    createdAt: formatUsageDate(usage.usedDate),
    statusChangedAt: '-',
    changelog: '-',
    refundedAmount: usage.refundedAmount,
    dateRank: usageDateRank(usage.usedDate)
  };
}

// Devuelve las filas de la tabla, de la fecha más reciente a la más antigua. Ante la misma
// fecha los reembolsos van primero y cada fuente conserva su orden de llegada (el orden de
// `Array.prototype.sort` es estable).
export function buildCoverageUsageRows(refundRows, usageRows) {
  const rows = [...refundRows.map(refundRow), ...usageRows.map(usageRow)];
  return rows.sort((a, b) => b.dateRank - a.dateRank);
}
